// Single source of truth for admin display labels that map enum bucket
// keys to human-readable strings. The survey itself stores the raw enum
// values (e.g. "5", "10", "0.50") — these labels are admin-display only.
//
// Any admin surface that renders a price or persona bucket should import
// from here. Keep in sync with /app/backend/admin.py INDIVIDUAL_PRICE_LABELS_BE
// and COLLEGE_PRICE_LABELS_BE so the CSV export and UI match.

export const INDIVIDUAL_PRICE_LABELS = {
    "0": "Free / Won't pay",
    "5": "₹399–499/mo",
    "10": "₹799–999/mo",
    "20": "₹1,499–1,999/mo",
    "30": "₹2,500+/mo",
};

export const COLLEGE_PRICE_LABELS = {
    "0.50": "Under ₹50/student",
    "1": "₹90/student",
    "2": "₹180/student",
    "5": "₹450/student",
    "10": "₹900+/student",
};

// Order used by the dashboard chart so bars render in ascending price.
export const INDIVIDUAL_PRICE_ORDER = ["0", "5", "10", "20", "30"];
export const COLLEGE_PRICE_ORDER = ["0.50", "1", "2", "5", "10"];

export function individualPriceLabel(key) {
    if (key == null || key === "") return "—";
    return INDIVIDUAL_PRICE_LABELS[String(key)] || `₹${key}`;
}

export function collegePriceLabel(key) {
    if (key == null || key === "") return "—";
    return COLLEGE_PRICE_LABELS[String(key)] || `₹${key}`;
}
